import { useNavigate, useParams } from 'react-router';
import {
  PaymentModeDetail,
  useFetchPaymentModeDetails,
} from '../../../../services/MySubmissions';
import { PageHeaderWithBackButton, Spin } from '../../../../components/common';
import style from './style.module.css';
import { Button, Table } from 'fave-ui';
import { ColumnsType } from 'antd/lib/table';
import { calcTableHeight } from '../../../../utils/utilFunctions';
import { mySubmissionElementIDs } from '../../elementId';

const tableHeight = calcTableHeight();

const PaymentModeSubmissionsDetailsView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const paymentModeId = String(id);

  const { data: paymentModesData, isFetching: isFetchingPaymentModeDetails } =
    useFetchPaymentModeDetails({
      payment_mode_id: paymentModeId,
    });

  const PaymentModeTable = () => (
    <>
      {paymentModesData?.payment_modes.map((paymentMode, paymentModeIndex) => {
        const columns: ColumnsType<PaymentModeDetail> = [
          {
            title: 'Payment Mode',
            dataIndex: 'payment_mode',
            width: 200,
            onCell: (record, recordIndex) => {
              const parsedIndex = recordIndex as number;

              // to show payment mode row only once
              const showPaymentModeRow =
                parsedIndex === 0 ||
                record.payment_mode !==
                  // to get the previous payment mode
                  paymentMode.payment_mode_rows[parsedIndex - 1].payment_mode;

              if (showPaymentModeRow) {
                // to get the number of rows with the same payment mode
                const rowSpan = paymentMode.payment_mode_rows.filter(
                  item => item.payment_mode === record.payment_mode,
                ).length;

                // will expand first row to cover all rows with the same payment mode
                return { rowSpan };
              } else {
                // other rows with the same payment mode will be hidden
                return { rowSpan: 0 };
              }
            },
          },
          {
            title: 'Variant(s)',
            dataIndex: 'variant_name',
            width: 200,
          },
          {
            title: 'Rate %',
            dataIndex: 'rates',
            width: 200,
          },
        ];

        const showEditAndResubmitButton =
          paymentModesData.submission_status === 'Pending Ack.' ||
          paymentModesData.submission_status === 'Cancelled' ||
          paymentModesData.submission_status === 'Pending signature';

        const onClickEditAndResubmit = () =>
          navigate(
            `/admin/merchant_connect/my_merchant/merchants/${paymentModesData.company_id}/payment_mode/edit?mc_contract_submission_ids=${paymentModesData.id}&merchant_type=fave&outlet_ids=${paymentMode.outlet_ids}&resubmit=true`,
          );

        return (
          <div key={paymentModeIndex} className={style.container}>
            <div className="flex items-center justify-between mb-4">
              <p className="font-bold mb-0">{`Outlets: ${paymentMode.outlet_names}`}</p>
              {showEditAndResubmitButton && (
                <Button
                  type="primary"
                  onClick={onClickEditAndResubmit}
                  data-id={`${mySubmissionElementIDs.paymentModeEditAndResubmitBtn}-${paymentModeIndex}`}
                >
                  Edit & Resubmit
                </Button>
              )}
            </div>
            <Table
              className={style.table}
              columns={columns}
              dataSource={paymentMode.payment_mode_rows}
              pagination={{
                pageSize: paymentMode.payment_mode_rows.length,
                hideOnSinglePage: true,
              }}
              rowKey={record => `${record.payment_mode}-${record.variant_name}`}
            />
          </div>
        );
      })}
    </>
  );

  return (
    <>
      <PageHeaderWithBackButton
        title={paymentModesData?.company_name}
        subTitle={'Payment Mode Submission'}
      />
      <div style={{ height: tableHeight }}>
        {isFetchingPaymentModeDetails && <Spin />}
        <PaymentModeTable />
      </div>
    </>
  );
};

export default PaymentModeSubmissionsDetailsView;
